/**
 * OrbDocIndexENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocIndexENSiteHeaderLanguages
 */

import { useOrbDocIndexENSiteHeaderLanguagesLogic } from '@/hooks/traits/useOrbDocIndexENSiteHeaderLanguagesLogic';
import type { OrbDocIndexENSiteHeaderLanguagesConfig } from '@/hooks/traits/useOrbDocIndexENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocIndexENDocView as OrbDocIndexENDocViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface OrbDocIndexENSiteHeaderLanguagesViewProps {
  config?: Partial<OrbDocIndexENSiteHeaderLanguagesConfig>;
}

export function OrbDocIndexENSiteHeaderLanguagesView({ config: propsConfig }: OrbDocIndexENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocIndexENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocIndexENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocIndexEN" trait="OrbDocIndexENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu position="bottom-end" className={((([{ code: "en" as const, href: "/docs" as const, label: "English" as const }, { code: "ar" as const, href: "/ar/docs" as const, label: "العربية" as const }, { code: "sl" as const, href: "/sl/docs" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} trigger={<Button variant="ghost" size="sm" icon="globe" label={String(__locale.toUpperCase())} />} items={Array.isArray(([{ code: "en" as const, href: "/docs" as const, label: "English" as const }, { code: "ar" as const, href: "/ar/docs" as const, label: "العربية" as const }, { code: "sl" as const, href: "/sl/docs" as const, label: "Slovenščina" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) ? (((([{ code: "en" as const, href: "/docs" as const, label: "English" as const }, { code: "ar" as const, href: "/ar/docs" as const, label: "العربية" as const }, { code: "sl" as const, href: "/sl/docs" as const, label: "Slovenščina" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} />) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocIndexENSiteHeaderLanguagesView;
